<div class="box">
  <section class="side-margin">
    <header [ngStyle]="{ 'max-width': !flagAreaPrivada ? '1280px' : '100%' }">
      <div class="content--list">
        <a class="logo-img" routerLink="/" (mouseenter)="onClearTooltip()">
          <img src="../../../assets/img/logo.svg" alt="Inviertis" />
        </a>
        <div>
          <button
            class="call-me-now btns mobile"
            id="btn-callmeback-header"
            (click)="openCallModal()"
            (mouseenter)="onClearTooltip()"
          >
            <img
              class="icon-btn"
              src="{{ picturesServer }}img/home/icono-telefono.svg"
              alt="Ícono teléfono"
              width="24"
              height="24"
            />
          </button>
          <button
            class="menu-btn-side-nav"
            aria-label="Abrir menú principal”"
            (click)="toogleSide()"
          >
            <i class="fa-solid fa-bars"></i>
          </button>
        </div>
      </div>
      <div class="content--menu">
        <div class="wraper--menu">
          <a
            *ngIf="!flagAreaPrivada"
            [routerLink]="[
              '/' + translateService.getCurrentLang() + '/invertir'
            ]"
            id="btn-buy"
            class="menu-btn"
            (mouseenter)="openMenu('invest')"
            (mouseleave)="scheduleMenuClose()"
            (click)="goNavigateToUrl('invertir')"
            routerLinkActive="active"
          >
            <span>{{ 'components.header.invest' | translate }}</span>
            <i
              class="fa-solid ms-2"
              [ngClass]="showSliderInvest ? 'fa-chevron-up' : 'fa-chevron-down'"
            ></i>
          </a>

          <div
            *ngIf="showSliderInvest"
            class="slider-invertir-container"
            (mouseenter)="cancelMenuClose()"
            (mouseleave)="scheduleMenuClose()"
          >
            <app-nav-tooltip-invest
              (cardSelected)="onCardSelected($event)"
              (closeTooltip)="showSliderInvest = $event"
            ></app-nav-tooltip-invest>
          </div>

          <a
            *ngIf="!flagAreaPrivada"
            [routerLink]="['/' + translateService.getCurrentLang() + '/vende']"
            id="btn-sell"
            class="menu-btn"
            routerLinkActive="active"
            (mouseenter)="openMenu('sell')"
            (mouseleave)="scheduleMenuClose()"
          >
            <span>{{ 'components.header.sell' | translate }}</span>
            <i
              class="fa-solid ms-2"
              [ngClass]="showSliderSell ? 'fa-chevron-up' : 'fa-chevron-down'"
            ></i>
          </a>

          <div
            *ngIf="showSliderSell"
            class="slider-invertir-container"
            (mouseenter)="cancelMenuClose()"
            (mouseleave)="scheduleMenuClose()"
          >
            <app-nav-tooltip-sell
              (closeTooltip)="showSliderSell = $event"
            ></app-nav-tooltip-sell>
          </div>
          <a
            *ngIf="!flagAreaPrivada"
            [routerLink]="[
              '/' +
                translateService.getCurrentLang() +
                '/como-funciona/consulting'
            ]"
            id="btn-how-it-works"
            class="menu-btn"
            routerLinkActive="active"
            (mouseenter)="openMenu('howItWorks')"
            (mouseleave)="scheduleMenuClose()"
          >
            <span>{{ 'components.header.howItWorks' | translate }}</span>
            <i
              class="fa-solid ms-2"
              [ngClass]="
                showSliderHowItWorks ? 'fa-chevron-up' : 'fa-chevron-down'
              "
            ></i>
          </a>

          @if (showSliderHowItWorks) {
          <div
            class="slider-invertir-container"
            (mouseenter)="cancelMenuClose()"
            (mouseleave)="scheduleMenuClose()"
          >
            <app-nav-tooltip-how-it-works
              (closeTooltip)="showSliderHowItWorks = $event"
            ></app-nav-tooltip-how-it-works>
          </div>
          }

          <!-- <a
            *ngIf="!flagAreaPrivada"
            [routerLink]="[
              '/' + translateService.getCurrentLang() + '/servicios/seguros'
            ]"
            class="menu-btn"
            routerLinkActive="active"
            (mouseenter)="onClearTooltip()"
          >
            <span>{{ 'components.header.services' | translate }}</span>
          </a> -->
          <a
            *ngIf="!flagAreaPrivada"
            [routerLink]="['sobre-nosotros']"
            (click)="goNavigateToUrl('sobre-nosotros')"
            class="menu-btn"
            routerLinkActive="active"
            (mouseenter)="onClearTooltip()"
          >
            <span>{{ 'components.header.aboutInviertis' | translate }}</span>
          </a>
          <a
            href="https://blog.inviertispro.com"
            class="menu-btn"
            target="_blank"
            (mouseenter)="onClearTooltip()"
          >
            <span>{{ 'components.header.blog' | translate }}</span>
          </a>
        </div>
        <div class="wraper--login">
          <button
            class="call-me-now btns"
            id="btn-callmeback-header"
            (click)="openCallModal()"
          >
            <img
              class="icon-btn"
              src="{{ picturesServer }}img/home/icono-telefono.svg"
              alt="Ícono teléfono"
              width="24"
              height="24"
            />
            {{ 'components.footer.Te llamamos' | translate }}
          </button>
          <button
            id="btn-register"
            class="btns create"
            (click)="openSignInModal()"
            routerLinkActive="active"
            *ngIf="!credentialsService.isAuthenticated()"
          >
            <i class="fa-solid fa-user"></i>
            <span>{{ 'components.header.createAccount' | translate }}</span>
          </button>
          <button
            id="btn-login"
            class="btns entrar"
            (click)="openLoginModal()"
            routerLinkActive="active"
            *ngIf="!credentialsService.isAuthenticated()"
          >
            <span>{{ 'components.header.enter' | translate }}</span>
          </button>

          <div *ngIf="credentialsService.credentials" style="height: 100%">
            <button class="user-btn" [matMenuTriggerFor]="menu">
              <i class="fa-solid fa-user"></i>
              <span>
                {{ credentialsService.credentials?.first_name }}
              </span>
              <i class="fa-solid fa-chevron-down"></i>
            </button>
            <mat-menu #menu="matMenu" class="user-menu">
              <button
                *ngIf="credentialsService.hasAnyAuthority(['ROLE_AGENT', 'ROLE_ADMIN'])"
                class="btn-menu"
                mat-menu-item
                (click)="navigateToUrl('tablero-de-usuario/asesor-ia')"
              >
                <span class="submenu-item"
                  >{{ 'components.menuDashboard.aiAdvisor' | translate }}</span
                >
              </button>
              <button
                class="btn-menu"
                mat-menu-item
                (click)="navigateToUrl('tablero-de-usuario/mi-cuenta')"
              >
                <span class="submenu-item"
                  >{{ 'components.header.account' | translate }}</span
                >
              </button>
              <button
                class="btn-menu"
                mat-menu-item
                (click)="navigateToUrl('tablero-de-usuario/mi-cartera')"
              >
                <span class="submenu-item"
                  >{{ 'components.header.properties' | translate }}</span
                >
              </button>
              <button
                class="btn-menu"
                mat-menu-item
                (click)="navigateToUrl('tablero-de-usuario')"
              >
                <span class="submenu-item"
                  >{{ 'components.header.favorites' | translate }}</span
                >
              </button>
              <button
                class="btn-menu"
                mat-menu-item
                (click)="navigateToUrl('tablero-de-usuario/mis-busquedas')"
              >
                <span class="submenu-item"
                  >{{ 'components.header.searches' | translate }}</span
                >
              </button>
              <button
                class="btn-menu"
                mat-menu-item
                (click)="logout()"
                style="border-top: 1px #e5e5e5 solid"
              >
                <span class="submenu-item">
                  {{ 'components.header.logout' | translate }}
                </span>
                <i class="fa-solid fa-arrow-right-from-bracket"></i>
              </button>
            </mat-menu>
          </div>
        </div>
      </div>
    </header>
  </section>
</div>
